import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./store";

//import TagManager from "react-gtm-module";
import { PersistGate } from "redux-persist/integration/react";
import TGMainLoader from "./shared/tg-main-loader";
import { handleRuntimeChunkError } from "./utils/runtimeErrorHandler";
const App = /*#__PURE__*/lazy(() => import("./App"));
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
const root = ReactDOM.createRoot(document.getElementById("root"));
async function startApp() {
  i18n.on("initialized", async () => {
    // TagManager.initialize(tagManagerArgsJpReg);
    handleRuntimeChunkError();
    root.render( /*#__PURE__*/React.createElement(Provider, {
      store: store
    }, /*#__PURE__*/React.createElement(PersistGate, {
      loading: null,
      persistor: persistor
    }, /*#__PURE__*/React.createElement(I18nextProvider, {
      i18n: i18n
    }, /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(TGMainLoader, {
        isGlobal: false,
        customClassName: "suspense-loader"
      })
    }, /*#__PURE__*/React.createElement(App, null))))));
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
startApp();